enum FormEntryType {
    ConnectionCard_V1 = 'Connection Card 1.0',
    ConnectionForm_V2 = 'Connection Form 2.0',
}

export default FormEntryType;
